import script from "./SidePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SidePanel.vue?vue&type=script&setup=true&lang=js"

import "./SidePanel.vue?vue&type=style&index=0&id=660c1b42&lang=scss"
import "./SidePanel.vue?vue&type=style&index=1&id=660c1b42&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660c1b42"]])

export default __exports__